














import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { SVGPathData, SVGPathDataTransformer, SVGPathDataParser } from 'svg-pathdata';
import { QRcodeLayer } from '@/model/document2/page/surface/design/layer/qrcodeLayer';
import { CodeHelper } from '@/helper/codeHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UnitHelper } from '@/helper/unitHelper';
import { FontManager } from '@/model/fontManager/fontManager';
import { InsertionHelper } from '../../../../../helper/insertionHelper';

@Component({
    components: {
    },
})
export default class QRcodeLayerDrawer extends Vue 
{
    private static readonly ERROR_MESSAGE = "バージョン又は表示領域が\n足りません";
    private static readonly ERROR_MESSAGE_COLOR = "#4A4A4A";
    private static readonly ERROR_MESSAGE_FONT_ID = "noto-sans-jp-400";

    // 最小フォントサイズ(pt)
    static readonly MIN_FONT_SIZE = 1;
    static readonly MAX_FONT_SIZE = 720;
  
    @Prop() private layer!: QRcodeLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;

    // レイヤーを表示して良いか
    private get isVisible()
    {
        // テキストが存在する or 差し込み対象ではない -> 表示
        return (this.layer.text != "" ||
            InsertionHelper.isInsertionTargetLayer(this.layer, this.$store.getters.document) != true);
    }

    // エラーメッセージを表示していいか
    private get isErrorMessageVisible()
    {
        // レンダリングでは出さない
        if(this.isRendering) { return false; }
        // レイアウト、印刷プレビューでは出さない
        var path = this.$router.currentRoute.path;
        if(path == "/PrintSetting" || path == "/LayoutEditor") { return false; }
        return true;
    }

    // マウント済みフラグ
    private ismounted = false;
    mounted() { this.ismounted = true; }

    // エラーメッセージ

    // エラーメッセージの各行設定のメイン処理
    private getErrorMessageLines(fontSize : number)
    {
        // フォントスタイル
        var fontSizePx = UnitHelper.convert(fontSize, "pt", "px");
        var style = {
            "font-size" : fontSizePx,
            "font-style" : "bold",
            "fill" : QRcodeLayerDrawer.ERROR_MESSAGE_COLOR
        };
        var fontManager : FontManager = this.$store.getters.fontManager;
        var fontFamily = fontManager.getFontFamilyName(QRcodeLayerDrawer.ERROR_MESSAGE_FONT_ID, false, this.isRendering, false)

        var array = new Array();
        var lines = QRcodeLayerDrawer.ERROR_MESSAGE.split(/\r?\n/g);
        var y = 0;
        for(var i = 0; i < lines.length; ++i)
        {
            var line = lines[i];
            // サイズ計測
            var size = StringHelper.calcTextSizeOnSVGPt(line, fontSizePx / 10, fontFamily);
            size.width *= 10;
            size.height *= 10;
            y += size.height;
            array.push({
                text : line,
                x : 0,
                y : y,
                style : style,
                fontFamily : fontFamily,
                width : size.width,
                height : size.height
            });
        }
        return array;
    }

    private get errorMessageLines()
    {
        var array = new Array();
        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return new Array(); }

        // サイズを確定する
        var tryFontSize = 1;
        var tryBeforeFontSize = 1;
        var step = 20;
        while(true)
        {
            // 仮に配置してみる
            array = this.getErrorMessageLines(tryFontSize);
            // 文字群の幅・高さを求める
            var minX = 0;
            var minY = 0;
            var maxX = 0;
            var maxY = 0;
            for(var i = 0; i < array.length; ++i)
            {
                var info = array[i];
                if(i == 0 || info.x < minX) { minX = info.x; }
                if(i == 0 || info.y < minY) { minY = info.y; }
                if(i == 0 || info.x + info.width > maxX) { maxX = info.x + info.width; }
                if(i == 0 || info.y + info.height > maxY) { maxY = info.y + info.height; }
            }
            var totalWidth = maxX - minX;
            var totalHeight = maxY - minY;

            if(totalWidth > this.layer.width * this.scale || totalHeight > this.layer.height * this.scale)
            {
                // レイヤー領域を超えてしまったので、フォントサイズを再設定する
                if(step == 20) { step = 10; }
                else if(step == 10) { step = 5; }
                else if(step == 5) { step = 2; }
                else if(step == 2) { step = 1; }
                else if(step == 1) { step = 0.3; }
                else if(step == 0.3) { step = 0.1; }
                else 
                {
                    // 以前のサイズで決定する
                    break;
                }

                // 以前のサイズにstepを加えて再チャレンジする
                tryFontSize = tryBeforeFontSize + step;
            }
            else
            {
                // レイヤー領域を超えない。stepを加えてもう一度計測する
                tryBeforeFontSize = tryFontSize;
                tryFontSize += step;
            }
            
            if(tryFontSize <= 0)
            {
                tryFontSize = QRcodeLayerDrawer.MIN_FONT_SIZE;
                break;
            }

            if(tryFontSize >= QRcodeLayerDrawer.MAX_FONT_SIZE)
            {
                tryFontSize = QRcodeLayerDrawer.MAX_FONT_SIZE;
                tryBeforeFontSize = tryFontSize;
                break;
            }

            // フォントサイズ決定
            array = this.getErrorMessageLines(tryBeforeFontSize);
        }

        return array;
    }

    private get imageSource() : string
    {
        return CodeHelper.createQRcode(this.layer.text, this.layer.version, this.layer.errorCorrection, this.layer.margin);
    }

    private get width()
    {
        return this.layer.width;
    }

    private get height()
    {
        return this.layer.height;
    }

    private get imageWidth()
    {
        return Math.min(this.layer.width, this.layer.height);
    }

    private get imageHeight()
    {
        return Math.min(this.layer.width, this.layer.height);
    }

    public get transform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // スケーリング
        transform += "scale(" + this.scale + ")";
        
        return transform;
    }

    private get textTransform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + ")";
        
        return transform;
    }

    public get imageTransform() : string
    {
        var transform = "";

        // オフセット + 画像を中央寄せ
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // 画像の中央寄せ
        var deltaX = 0;
        var deltaY = 0;
        if(this.layer.width > this.layer.height)
        {
            deltaX += (this.layer.width - this.layer.height) * this.scale / 2;
        }
        else
        {
            deltaY += (this.layer.height - this.layer.width) * this.scale / 2;
        }
        transform += "translate(" + deltaX + " " + deltaY + "),";

        // スケーリング
        transform += "scale(" + this.scale + ")";
        
        return transform;
    }
}
